import { mobileModel, osName } from 'react-device-detect';

export const getDeviceInfo = (platform: string) => ({
  device_model: mobileModel,
  device_platform: platform,
  device_os: osName,
});
